import { Badge } from "@/components/shadcn/badge";
import { cn } from "@/lib/utils";

const RELEASE_STATUS_CONFIG = {
  alpha: "bg-amber-100 text-amber-800",
  beta: "bg-muted-foreground/20",
  deprecated: "bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300",
} as const;

type ReleaseStatus = keyof typeof RELEASE_STATUS_CONFIG;

export const ReleaseStatusBadge = ({
  status,
  className,
}: {
  status: ReleaseStatus;
  className?: string;
}) => (
  <Badge
    variant="secondary"
    className={cn(
      "h-4 shrink-0 px-1.5 text-[10px] font-medium uppercase tracking-wide",
      RELEASE_STATUS_CONFIG[status],
      className
    )}
  >
    {status}
  </Badge>
);
